import { observer } from "mobx-react";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import { BUTTON_VARIANTS } from "../../../../../../components/inputs/button-variants";
import { Button } from "../../../../../../components/inputs/button/button";
import IconPlay from "../../../../../../components/icons/icon-play/icon-play";
import { useState } from "react";
import "./help-videos-button.scss";
import currentPortalStore from "../../../../../../stores/current-portal-store";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import HelpVideoModal from "./help-video-modal/help-video-modal";
import rmsMixpanelStore from "../../../../../../stores/rms-mixpanel-store";

const HelpVideosButton: React.FC = observer(() => {
    const [isShowHelpVideoModal, setIsShowHelpVideoModal] = useState(false);
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-home';
    const onPlayVideosClick = () => {
        rmsMixpanelStore.trackEvent('d&_home_help_play_videos');
        setIsShowHelpVideoModal(true);
    }

    return (
        <div className='help-videos-button-container'>
            <FontBody1>
                {!!currentPortalStore.setting?.isMerchantOnboarded  ? (
                    getTranslation('WATCH_SOLUTION_OVERVIEW_TO_LEARN_MORE', scope)
                ) : (
                    getTranslation('LEARN_MORE_ABOUT_PORTAL_WITH_VIDEOS', scope)
                )}
            </FontBody1>
            <div>
                <Button
                    onClick={onPlayVideosClick}
                    leftIcon={IconPlay}
                    variant={BUTTON_VARIANTS.Secondary}
                    text={getTranslation('PLAY_VIDEOS', scope)}
                />
            </div>

            <HelpVideoModal isOpen={isShowHelpVideoModal} onCloseClicked={() => setIsShowHelpVideoModal(false)} />
        </div>
    );
});

export default HelpVideosButton;
